import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

// Tap-sized back affordance, matching BackLinkFromProduct/YPX. ≥40px tall
// so it works comfortably on mobile, outlined pill style with visible
// hover/focus state. Used on category sub-category pages, yearbook, and
// the unsubscribe flow.
const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  min-height: 40px;
  margin: 16px 0 20px;
  background: transparent;
  color: #479de6;
  border: 1px solid #479de6;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.1s ease, color 0.1s ease;

  &:hover,
  &:focus {
    background: #f3f8fd;
    color: #357ab8;
    outline: none;
    text-decoration: none;
  }
`;

const BackLink = ({ history, onClick, className, style }) => (
  <BackButton
    type="button"
    className={className}
    style={style}
    onClick={onClick || history.goBack}
    aria-label="Go back"
  >
    <span aria-hidden="true">←</span> Back
  </BackButton>
);

export default withRouter(BackLink);
